/** @jsxImportSource @emotion/react */
// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./FunctionCardStyles";
// @otg-one/ui_components/components
import { Typography } from "../index";
// @otg-one/ui_components/icons
import { FunctionGoodsReceipt } from "../../icons";
// @otg-one/ui_components/constants
import { FONT_FAMILY, Color } from "../../constants";

export const FunctionCard = (props) => {
    const classes = useStyles(props);
    const { id, textDevice, icon, onClick, style } = props;

    return (
        <div
            css={classes.functionCardContainer}
            onClick={onClick}
            style={style}
            id={id}
        >
            <div css={classes.functionIconContainer}>
                {icon}
            </div>
            <Typography
                fontFamily={FONT_FAMILY.ROBOTO_MEDIUM}
                size={16}
                color={Color.neutral[0]}
                css={classes.functionIconTypography}
            >
                {textDevice}
            </Typography>
        </div>
    );
};

FunctionCard.defaultProps = {
    textDevice: "Device",
    icon: <FunctionGoodsReceipt />,
    onClick: () => {},
};

export default React.memo(FunctionCard);
